/*
 * @Author: “zhangjiahao04” “zhangjiahao04@beyondsoft.com”
 * @Date: 2023-08-23 15:50:14
 * @LastEditors: caiqin.xie
 * @LastEditTime: 2023-09-18 14:55:40
 * @FilePath: \pico-ow2c-fe\src\pages\outer\home\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Header from "@/components/Header/index";
import Footer from "@/components/Footer/index";
import styles from "./index.module.scss";
import ProductPreview from "./components/ProductPreview";
import ProductList from "./components/ProductList";
import DevGame from "./components/DevGame";
import GameSlider from "./components/GameSlider";
import ProductsIntroduction from "./components/ProductsIntroduction";
import BottomNav from "./components/BottomNav";
import Banner from "./components/Banner";
import NewsSlider from "./components/NewsSlider"
import request from '@/common/request'
import { DOMAIN_API, HOMEBANNER1, HOMEBANNER2, HOMEBANNER3, HOMEBANNER4, HOMEBANNER5, COUNTRY_LIST, COUNTRY_HREFLANG } from '@/common/const'
import { useDevice } from '@/hooks'

const Home = (props: any) => {
  const { ctry, words, data: { banners, banners2, banners3, banners4, banners5, newsContents, products } } = props.data
  const device = useDevice()

  // 生成hreflang
  const renderHrefLang = () => {
    return (
      COUNTRY_LIST.map(item => (
        <link key={item} rel="alternate" hrefLang={COUNTRY_HREFLANG[item]} href={`${DOMAIN_API}/${item}/support`} />
      ))
    )
  }
  return (
    <div>
      <Helmet>
        <title>{words?.home_seo_title}</title>
        <meta name="description" content={words?.home_seo_description} />
        <meta name="keywords" content={words?.home_seo_keywords} />
        <link rel="canonical" href={`${DOMAIN_API}/${ctry}`} />
        {renderHrefLang()}
      </Helmet>
      <Header ctry={ctry} words={words} />
      <main className={styles.page}>
        {/* banner */}
        {banners?.length > 0 && <Banner words={words} bannerList={banners ?? []} device={device} ctry={ctry}></Banner>}
        {/* 产品轮播 */}
        {banners2?.length > 0 && <ProductPreview productPreviewList={banners2 ?? []} words={words} device={device} ctry={ctry}/>}
        {/* 产品列表 */}
        {products?.length > 0 && <ProductList productList={products ?? []} words={words} ctry={ctry} />}
        {/* 游戏banner */}
        {banners3?.length > 0 && <DevGame words={words} devGameList={banners3 ?? []}  ctry={ctry} device={device}/>}
        {/* 游戏轮播 */}
        {banners5?.length > 0 && <GameSlider gameContentsList={banners5 ?? []} ctry={ctry} words={words} device={device}></GameSlider>}
        {/* 产品介绍 */}
        <ProductsIntroduction words={words} ctry={ctry} device={device} productsIntroList={banners4 ?? []} ></ProductsIntroduction>
        {/* 新闻 News */}
        {newsContents?.length > 0 && <NewsSlider newsContents = {newsContents ?? []} ctry={ctry} words={words} device={device}></NewsSlider>}
        {/* 底部导航 */}
        <BottomNav ctry={ctry} words={words}></BottomNav>
      </main>
      <Footer />
    </div>
  );
};
function getInit (ctry: string) {
  return new Promise((resolve, reject) => {
    request.post(`${DOMAIN_API}/o/official/home/getHomePage`, {
      bannerPositionId: HOMEBANNER1,//banner1 位置 id
      bannerPositionId2: HOMEBANNER2,//banner2 位置 id
      bannerPositionId3: HOMEBANNER3,//banner3 位置 id
      bannerPositionId4: HOMEBANNER4,//banner4 位置 id
      bannerPositionId5: HOMEBANNER5,//banner5 位置 id
      stationCode: ctry
    })
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      reject(err)
    })
  })
}
Home.getInitialProps = (ctry: string) => {
  return getInit(ctry)
};
export default Home;
